import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {ID} from "../../../core/metamodel/metaConstant";
import {observable} from "mobx";
import {ProjectVersion} from "./projectVersionDomain";
import {LovItem} from "../../../core/metamodel/mdEntity";


@entityConfig()
export default class ProjectVersionTree extends DomainAncestor {

  @observable treeId : number;
  @observable projectVersion : ProjectVersion;
  @observable name : string;
  @observable trunkCircumference : number;
  @observable crownDiameter : number;
  @observable distanceFromFacade : number;
  @observable facadeOrientation : LovItem;
  @observable indigenous : boolean;
  @observable newlyPlanted : boolean;
  @observable cutDown : boolean;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.treeId;
  }

  public setId(id: ID): void {
    this.treeId = <number>id;
  }

}



// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionTreeDomain.ts